<!-- eslint-disable vue/no-lone-template -->
<template>
  <Teleport to="body">
    <cl-modal
      :close-modal-text="$t('close')"
      :visible="visible"
      test-id="saml-toggle-confirmation-modal"
      @on-close="onClose"
    >
      <template #[`header.title`]>
        <slot name="title">
          <cl-heading :size="'h4'">
            {{ t("enable-2fa") }}
          </cl-heading>
        </slot>
      </template>
      <slot name="body">
        <template v-if="status">
          <div class="tw-ml-6">
            <div
              v-dompurify-html="t('saml-enable-confirm-lead-in')"
              class="tw-pb-4"
            />
            <ul class="tw-list-disc">
              <li>
                {{ t("login-identity-provider") }}
              </li>
              <li>
                {{ t("login-username-password-error") }}
              </li>
            </ul>
            <p class="tw-mt-4">
              {{ t("saml-save-later") }}
              <b class="tw-flex">{{ t("save-configuration") }}</b>
            </p>
          </div>
        </template>
      </slot>
      <template #[`footer.decline`]>
        <slot name="decline">
          <cl-button
            variant="secondary-ghost"
            data-test-id="saml-confirmation-cancel"
            @on-click="onClose"
          >
            {{ t("cancel") }}
          </cl-button>
        </slot>
      </template>
      <template #[`footer.accept`]>
        <slot name="config">
          <cl-button
            :variant="'secondary-outline'"
            data-test-id="saml-confirmation-save-config"
            :disabled="isRequestPending"
            @on-click="saveConfig"
          >
            <cl-spinner
              :loading-text="$t('loading')"
              v-if="isRequestPending"
              :size="'small'"
              class="tw-mr-2"
            />
            <span>{{ t("save-configuration") }}</span>
          </cl-button>
        </slot>
        <slot name="enable">
          <cl-button
            variant="secondary"
            data-test-id="saml-confirmation-enable"
            :disabled="isRequestPending"
            @on-click="enable"
          >
            <cl-spinner
              :loading-text="$t('loading')"
              v-if="isRequestPending"
              :size="'small'"
              class="tw-mr-2"
            />
            <span>{{ t("enable-2fa") }}</span>
          </cl-button>
        </slot>
      </template>
    </cl-modal>
  </Teleport>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import {
  useRequestStatus,
  PENDING,
  READY,
} from "@/composables/useRequestStatus";

type Props = {
  visible?: boolean;
  status: boolean;
};
withDefaults(defineProps<Props>(), {
  visible: false,
});
const { t } = useI18n();

const { setRequestStatus, isRequestPending } = useRequestStatus({
  type: READY,
});

const emit = defineEmits<{
  (event: "on-save"): void;
  (event: "on-enable"): void;
  (event: "on-close"): void;
}>();

const onClose = () => {
  emit("on-close");
};
const enable = () => {
  setRequestStatus({ type: PENDING });

  emit("on-enable");

  setTimeout(() => {
    setRequestStatus({ type: READY });
  }, 1000);
};
const saveConfig = () => {
  setRequestStatus({ type: PENDING });

  emit("on-save");

  setTimeout(() => {
    setRequestStatus({ type: READY });
  }, 1000);
};
</script>
